<template>
    <b-modal
      no-close-on-backdrop
      centered
      ok-only
      size="lg"
      hide-footer
      v-model="open"
      title="Excluir Cupom"
      :busy="loading"
    >
      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-else class="container">
        <b-col cols="12" class="mb-4">
          <h4 class="text-center">Deseja realmente excluir o cupom ?</h4>
          <h3 class="text-center mt-4"><b-badge variant="warning">{{ data.coupon }}</b-badge></h3>
        </b-col>
        <b-col class="d-flex justify-content-around mt-2 mb-2">
          <b-button
            @click="open = false"
            variant="outline-warning"
          >Cancelar</b-button>
          <b-button
            variant="danger"
            @click="deleteCoupon()"
          >
            <i class="fas fa-trash mr-2"></i>
            Exluir
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </template>
  
  <script>
  import makeToast from '@/mixins/makeToast';
  import { mapState } from 'vuex';
  
  export default {
    name: 'ModalDeleteCoupon',
    mixins: [makeToast],
    emits: ['destroyCoupon'],
   
    data() {
      return {
        loading: false,
        open: false,
        data: []
      };
    },
    computed: {
    ...mapState(['dadosUsuario']),
    },
    methods: {
      toggleOpen(data = []) {
        this.open = !this.open;
        this.data = data.data;
      },
      deleteCoupon() {
        this.$emit('destroyCoupon', this.data.id);
        this.open = !this.open;
      }
    },
  };
  </script>
  